import React, { useState, useEffect, useRef } from 'react';
import './OpponentSelection.css';

function OpponentSelection({ userData, onStartCombat, onBack }) {
  console.log('OpponentSelection - userData recibido:', userData);
  console.log('OpponentSelection - cinturon:', userData?.cinturon);
  console.log('OpponentSelection - energia:', userData?.energia);
  
  const audioRef = useRef(null);
  
  const playHoverSound = () => {
    const sound = document.getElementById('hover-sound');
    if (sound) {
      sound.currentTime = 0;
      sound.volume = 0.3;
      sound.play().catch(e => console.log('Audio blocked'));
    }
  };

  const opponents = [
    { 
      id: 'novice', 
      name: 'NOVICIO', 
      belt: 'Blanco', 
      energy: 15, 
      img: '/assets/versus/novicio.png',
      requiredBelt: 'Blanco'
    },
    { 
      id: 'boosabon', 
      name: 'BOOSABON', 
      belt: 'Negro 1° Dan', 
      energy: 20, 
      img: '/assets/versus/boosabon.png',
      requiredBelt: 'Amarillo'
    },
    { 
      id: 'sabon', 
      name: 'SABON', 
      belt: 'Negro 2° Dan', 
      energy: 25, 
      img: '/assets/versus/sabon.png',
      requiredBelt: 'Verde'
    },
    { 
      id: 'sabon-nim', 
      name: 'SABON NIM', 
      belt: 'Negro 4° Dan', 
      energy: 30, 
      img: '/assets/versus/sabonnim.png',
      requiredBelt: 'Azul'
    },
    { 
      id: 'champion', 
      name: 'CAMPEÓN', 
      belt: 'Negro 3° Dan', 
      energy: 35, 
      img: '/assets/versus/woldchapion.png',
      requiredBelt: 'Rojo'
    },
    { 
      id: 'master', 
      name: 'MASTER', 
      belt: 'Negro 7° Dan', 
      energy: 40, 
      img: '/assets/versus/master.png',
      requiredBelt: 'Negro 1° Dan'
    },
    { 
      id: 'grandmaster', 
      name: 'GRAN MASTER', 
      belt: 'Negro 9° Dan', 
      energy: 50, 
      img: '/assets/versus/grandmaster.png',
      requiredBelt: 'Negro 7° Dan'
    }
  ];

  const [carouselIndex, setCarouselIndex] = useState(0);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.3;
      audioRef.current.play().catch(err => console.log('Error al reproducir audio:', err));
    }
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  const beltOrder = [
    'Blanco',
    'Blanco Punta Amarilla',
    'Amarillo',
    'Amarillo Punta Verde',
    'Verde',
    'Verde Punta Azul',
    'Azul',
    'Azul Punta Roja',
    'Rojo',
    'Rojo Punta Negra',
    'Negro 1° Dan',
    'Negro 2° Dan',
    'Negro 3° Dan',
    'Negro 4° Dan',
    'Negro 5° Dan',
    'Negro 6° Dan',
    'Negro 7° Dan',
    'Negro 8° Dan',
    'Negro 9° Dan - Gran Maestro'
  ];

  const canFightOpponent = (opponent) => {
    const userBelt = userData?.cinturon || 'Blanco';
    const userBeltIndex = beltOrder.indexOf(userBelt);
    const requiredBeltIndex = beltOrder.indexOf(opponent.requiredBelt);
    const userEnergy = userData?.energia || 100;
    
    console.log('Debug desbloqueo:', opponent.name, {
      userBelt,
      requiredBelt: opponent.requiredBelt,
      canFight: userBeltIndex >= requiredBeltIndex,
      hasEnergy: userEnergy >= opponent.energy
    });
    
    // Siempre desbloquear NOVICIO
    if (opponent.id === 'novice') {
      return userEnergy >= opponent.energy;
    }
    
    return userBeltIndex >= requiredBeltIndex && userEnergy >= opponent.energy;
  };

  const getBlockReason = (opponent) => {
    const userBelt = userData?.cinturon || 'Blanco';
    const userBeltIndex = beltOrder.indexOf(userBelt);
    const requiredBeltIndex = beltOrder.indexOf(opponent.requiredBelt);
    const userEnergy = userData?.energia || 100;
    
    if (userEnergy < opponent.energy) {
      return { type: 'energy', message: `Necesitas ${opponent.energy} energía` };
    }
    if (userBeltIndex < requiredBeltIndex) {
      return { type: 'belt', message: `Requiere ${opponent.requiredBelt}` };
    }
    return null;
  };

  const carouselNext = () => {
    setCarouselIndex(prev => Math.min(prev + 1, opponents.length - 1));
  };

  const carouselPrev = () => {
    setCarouselIndex(prev => Math.max(prev - 1, 0));
  };

  const getCardGap = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const isLandscape = w > h && h < 500;
    if (isLandscape) return 220;
    if (w <= 480) return 240;
    if (w <= 768) return 260;
    return 300;
  };
  const [cardGap, setCardGap] = useState(getCardGap);

  useEffect(() => {
    const onResize = () => setCardGap(getCardGap());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const touchStart = useRef(null);
  const handleTouchStart = (e) => { touchStart.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (touchStart.current === null) return;
    const diff = touchStart.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? carouselNext() : carouselPrev(); }
    touchStart.current = null;
  };

  const handleOpponentClick = async (opponent) => {
    const blockReason = getBlockReason(opponent);
    if (blockReason) {
      if (blockReason.type === 'energy') {
        alert(`⚡ ENERGÍA INSUFICIENTE\n\nNecesitas ${opponent.energy} de energía para enfrentar a ${opponent.name}.\nTu energía actual: ${userData?.energia || 0}\n\n💡 La energía se regenera con el tiempo o puedes comprar pociones en la tienda.`);
      } else {
        alert(`🥋 CINTURÓN REQUERIDO\n\nNecesitas cinturón ${opponent.requiredBelt} para enfrentar a ${opponent.name}.\nTu cinturón actual: ${userData?.cinturon || 'Blanco'}`);
      }
      return;
    }

    // Descontar energía al backend
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/combat/start`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          oponenteId: opponent.id,
          energiaCosto: opponent.energy
        })
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Energía descontada:', data);
        onStartCombat(opponent);
      } else {
        let errorMessage = 'Error al iniciar combate';
        try {
          const error = await response.json();
          errorMessage = error.message || errorMessage;
        } catch (parseError) {
          const textError = await response.text();
          console.error('Error del servidor (texto):', textError);
          errorMessage = textError || errorMessage;
        }
        alert(errorMessage);
      }
    } catch (error) {
      console.error('Error al descontar energía:', error);
      alert('Error de conexión con el servidor');
    }
  };

  return (
    <div className="combat-arena">
      <audio ref={audioRef} src="/audio/taekwondomaster.mp3" loop />
      <audio id="hover-sound" src="/audio/hover.mp3" preload="auto"></audio>
      
      {[...Array(30)].map((_, i) => (
        <div key={i} className="ash-particle"></div>
      ))}

      <div className="arena-header">
        <img src="/img/logo.png" alt="Logo" className="arena-logo" />
        <div className="energy-display">
          <span className="energy-icon">🔋</span>
          <span className="energy-value">{userData?.energia || 0}</span>
        </div>
        <button className="close-btn" onClick={onBack} onMouseEnter={playHoverSound}>✕</button>
      </div>

      <div className="opponents-container" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
        <button className="carousel-btn prev" onClick={carouselPrev} onMouseEnter={playHoverSound} disabled={carouselIndex === 0}>‹</button>
        <button className="carousel-btn next" onClick={carouselNext} onMouseEnter={playHoverSound} disabled={carouselIndex === opponents.length - 1}>›</button>

        <div className="opponents-wrapper">
          <div className="opponents-carousel">
          {opponents.map((opponent, index) => {
            const offset = index - carouselIndex;
            const isLocked = !canFightOpponent(opponent);
            const blockReason = getBlockReason(opponent);
            const isLegendary = opponent.id === 'grandmaster' || opponent.id === 'master';
            
            return (
              <div
                key={opponent.id}
                className={`menu-card ${offset === 0 ? 'active' : ''} ${isLegendary ? 'legendary' : ''} ${isLocked ? 'locked' : ''}`}
                style={{
                  transform: `translateX(${offset * cardGap}px) scale(${offset === 0 ? 1 : Math.max(0.65, 0.85 - Math.abs(offset) * 0.1)}) rotateY(${offset * -5}deg)`,
                  opacity: offset === 0 ? 1 : Math.max(0.3, 0.7 - Math.abs(offset) * 0.15),
                  filter: offset === 0 ? 'none' : `grayscale(${Math.min(80, Math.abs(offset) * 30)}%)`,
                  zIndex: 10 - Math.abs(offset),
                  pointerEvents: offset === 0 ? 'auto' : 'none',
                }}
                onClick={offset === 0 ? () => handleOpponentClick(opponent) : undefined}
                onMouseEnter={offset === 0 ? playHoverSound : undefined}
              >
                <div className="card-icon">
                  <img src={opponent.img} alt={opponent.name} />
                </div>
                <h3>{opponent.name}</h3>
                <p>{opponent.belt}</p>
                <div className="opponent-energy">🔋 -{opponent.energy} Energía</div>
                {isLocked && blockReason && (
                  <div className="lock-overlay">
                    <span className="lock-icon">{blockReason.type === 'energy' ? '⚡' : '🔒'}</span>
                    <p>{blockReason.message}</p>
                  </div>
                )}
              </div>
            );
          })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpponentSelection;
